import React from 'react';
import Navbar from './home/Navbar';
import Footer from './Footer';
import ZendeskPrompts from './ZendeskPrompts';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';

function ZendeskPromptsPage() {
  const { events } = useGoogleAnalytics();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    events.pageView('App Builder');
  }, [events]);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      <div className="flex-grow pt-16">
        <ZendeskPrompts />
      </div>
      <Footer />
    </div>
  );
}

export default ZendeskPromptsPage;